import { useState } from 'react';

import Transition from '@/components/Common/Transition';
import Modal from '@/components/Modal/Modal';
import type {
  Dashboard2FolderT,
  Dashboard2ListT,
  Dashboard2T,
} from '@/features/Dashboard/types/types';
import useModalState from '@/hooks/pure/useModalState';
import service from '@/services';

import DashboardFloatActionMenu from '../DashboardFloatActionMenu';
import DashboardModal from '../DashboardModal';
import DashboardListTable from './DashboardListTable';

const Dashboard2List = ({
  data,
  refetch,
  folderAlias,
  isLoading,
}: {
  data?: Dashboard2ListT;
  refetch: () => void;
  folderAlias: string | null;
  isLoading: boolean;
}) => {
  const [checkedList, setCheckedList] = useState<string[]>([]);

  const renameDashboardModalState = useModalState<Dashboard2T | null>(null);
  const renameDashboardFolderModalState =
    useModalState<Dashboard2FolderT | null>(null);

  return (
    <>
      <DashboardListTable
        folderAlias={folderAlias}
        data={data}
        onEditDashboard={(dashboard) => {
          renameDashboardModalState.setModalState(dashboard);
          renameDashboardModalState.open();
        }}
        onEditDashboardFolder={(dashboardFolder) => {
          renameDashboardFolderModalState.setModalState(dashboardFolder);
          renameDashboardFolderModalState.open();
        }}
        onSelectDashboard={setCheckedList}
        refetch={() => {
          refetch();
          setCheckedList([]);
        }}
        checkedList={checkedList}
        isLoading={isLoading}
      />

      <Modal
        status={renameDashboardModalState.status}
        closeModal={renameDashboardModalState.close}
      >
        <DashboardModal
          value={renameDashboardModalState.modalState?.title}
          onConfirm={async (dashboardName) => {
            if (!renameDashboardModalState.modalState) return;
            await service.dashboard2.changeDashboardTitle(
              renameDashboardModalState.modalState.alias,
              dashboardName,
            );
            renameDashboardModalState.close();
            refetch();
          }}
          title="Rename dashboard"
          label="Dashboard name"
          buttonLabel="Rename"
        />
      </Modal>

      <Modal
        status={renameDashboardFolderModalState.status}
        closeModal={renameDashboardFolderModalState.close}
      >
        <DashboardModal
          value={renameDashboardFolderModalState.modalState?.name}
          onConfirm={async (dashboardName) => {
            if (!renameDashboardFolderModalState.modalState) return;
            await service.dashboard2.changeDashboardFolderName(
              renameDashboardFolderModalState.modalState.alias,
              dashboardName,
            );
            renameDashboardFolderModalState.close();
            refetch();
          }}
          title="Rename folder"
          label="Folder name"
          buttonLabel="Rename folder"
        />
      </Modal>

      <Transition
        status={checkedList.length > 0}
        style={{
          position: 'absolute',
          bottom: 24,
          left: '50%',
          width: '100%',
          zIndex: 10,
        }}
      >
        <DashboardFloatActionMenu
          selectedList={checkedList}
          onClearListClick={() => {
            setCheckedList([]);
          }}
          refetchList={refetch}
          folders={data?.dashboard_folders}
        />
      </Transition>
    </>
  );
};

export default Dashboard2List;
